import cloudContactCenterN from "../assets/img/caseStudy/cloudContactCenterN.jpg";
import telehealthEngagementN from "../assets/img/caseStudy/telehealthEngagementN.png";
import payTvSubscriptionN from "../assets/img/caseStudy/payTvSubscriptionN.jpg";
import simFraudVerificationN from "../assets/img/caseStudy/simFraudVerificationN.jpg";
import assetFinanceDeviceAccessN from "../assets/img/caseStudy/assetFinanceDeviceAccessN.jpg";
import loanRecoveryDelinquencyN from "../assets/img/caseStudy/loanRecoveryDelinquencyN.png";
import commercialBankLoanRecoveryN from "../assets/img/caseStudy/commercialBankLoanRecoveryN.jpg";
import foodDeliveryOrderSupportN from "../assets/img/caseStudy/foodDeliveryOrderSupportN.jpg";
import backgroundVerificationN from "../assets/img/caseStudy/backgroundVerificationN.jpg";
import ispTechnicalSupportN from "../assets/img/caseStudy/ispTechnicalSupportN.jpg";
import loanDisbursementTelesalesN from "../assets/img/caseStudy/loanDisbursementTelesalesN.jpg";
import crossBorderPaymentsSlaN from "../assets/img/caseStudy/crossBorderPaymentsSlaN.jpg";
import mvnoMarketEntryN from "../assets/img/caseStudy/mvnoMarketEntryN.jpg";
import lendingInfrastructureWithdrawalN from "../assets/img/caseStudy/lendingInfrastructureWithdrawalN.png";
import gamingPlatformPlayerTrustN from "../assets/img/caseStudy/gamingPlatformPlayerTrustN.png";
import customerSatisfactionResearchN from "../assets/img/caseStudy/customerSatisfactionResearchN.png";
import insuranceCustomerServiceN from "../assets/img/caseStudy/insuranceCustomerServiceN.jpg";
import fintechLoanRecoveryN from "../assets/img/caseStudy/fintechLoanRecoveryN.jpg";
import highPerformingContactCenterN from "../assets/img/caseStudy/highPerformingContactCenterN.jpg";
import subscriptionLoyaltyN from "../assets/img/caseStudy/subscriptionLoyaltyN.jpg";
import digitalSavingsSupportN from "../assets/img/caseStudy/digitalSavingsSupportN.jpg";
import fintechSupportEfficiencyN from "../assets/img/caseStudy/fintechSupportEfficiencyN.jpg";
import debtRecoveryFinancialInstitutionN from "../assets/img/caseStudy/debtRecoveryFinancialInstitutionN.jpg";
import telecomCustomerSupportN from "../assets/img/caseStudy/telecomCustomerSupportN.jpg";
import govtCloudContactCentreN from "../assets/img/caseStudy/govtCloudContactCentreN.jpg";
import govtInboundOutsourcingN from "../assets/img/caseStudy/govtInboundOutsourcingN.jpg";

export const caseStudyImages = {
  cloudContactCenterN,
  telehealthEngagementN,
  payTvSubscriptionN,
  simFraudVerificationN,
  assetFinanceDeviceAccessN,
  loanRecoveryDelinquencyN,
  commercialBankLoanRecoveryN,
  foodDeliveryOrderSupportN,
  backgroundVerificationN,
  ispTechnicalSupportN,
  loanDisbursementTelesalesN,
  crossBorderPaymentsSlaN,
  mvnoMarketEntryN,
  lendingInfrastructureWithdrawalN,
  gamingPlatformPlayerTrustN,
  customerSatisfactionResearchN,
  insuranceCustomerServiceN,
  fintechLoanRecoveryN,
  highPerformingContactCenterN,
  subscriptionLoyaltyN,
  digitalSavingsSupportN,
  fintechSupportEfficiencyN,
  debtRecoveryFinancialInstitutionN,
  telecomCustomerSupportN,
  govtCloudContactCentreN,
  govtInboundOutsourcingN,
};